export const actionTypes = {
  selectOrder: "SELECT_ORDER",
  setReference: "SET_REFERENCE",
  // setDropOffAddress: "SET_DROP_OFF_ADDRESS",
  addProduct: "ADD_PRODUCT",
  removeProduct: "REMOVE_PRODUCT",
  changeTotalUnit: "CHANGE_TOTAL_UNIT",
  setFormDataStep1: "SET_FORM_DATA_STEP_1",
  setFormDataStep2: "SET_FORM_DATA_STEP_2",
};

export const initialState = {
  reference: undefined,
  selectedOrder: undefined,
  // dropOfAddress: [],
  products: [],
  formDataStep1: [],
  formDataStep2: [],
};

const productReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.setReference:
      return {
        ...state,
        reference: payload,
      };
    case actionTypes.selectOrder:
      return {
        ...state,
        selectedOrder: payload,
      };
    case actionTypes.setDropOffAddress:
      return {
        ...state,
        dropOfAddress: payload,
      };
    case actionTypes.addProduct:
      return {
        ...state,
        products: [...state.products, ...payload],
      };

    case actionTypes.removeProduct:
      return {
        ...state,
        products: state.products.filter((item) => item._id !== payload),
      };
    case actionTypes.changeTotalUnit:
      const { id, totalUnit } = payload;
      return {
        ...state,
        products: state.products.map((item) => {
          if (item._id === id) {
            item.totalUnitReturn = totalUnit;
          }
          return item;
        }),
      };
    case actionTypes.setFormDataStep1:
      return {
        ...state,
        formDataStep1: payload,
      };
    case actionTypes.setFormDataStep2:
      return {
        ...state,
        formDataStep2: payload,
      };

    default:
      break;
  }
};

export default productReducer;
